module.exports = __webpack_public_path__ + "img/photoAlbum1.37c2d5e2.jpg";